/**
 * Английский перевод.
 *
 * Ключ — русский текст из кода; порядок разделов совпадает с uz.ts.
 * Термины наземного обслуживания даны в принятом в отрасли виде:
 * pushback tug, belt loader, ambulift, de-icer, GPU, ASU.
 */
export const en: Record<string, string> = {
  // ─── Навигация ────────────────────────────────────────────────────────────
  Главная: 'Dashboard',
  HR: 'HR',
  Сотрудники: 'Employees',
  Структура: 'Structure',
  Должности: 'Positions',
  Автопарк: 'Fleet',
  Транспорт: 'Vehicles',
  Водители: 'Drivers',
  Техконтроль: 'Technical control',
  Телеметрия: 'Telemetry',
  Эксплуатация: 'Operations',
  'Путевые листы': 'Waybills',
  ГСМ: 'Fuel',
  Здравпункт: 'Medical point',
  'Склад ТМЦ': 'Warehouse',
  Отчёты: 'Reports',
  Пользователи: 'Users',
  Справочники: 'Reference data',
  Администрирование: 'Administration',
  'Журнал действий': 'Audit log',
  'Свернуть меню': 'Collapse menu',
  'Развернуть меню': 'Expand menu',
  'Версия платформы': 'Platform version',
  'Изменить ширину меню': 'Resize menu',
  Выйти: 'Sign out',

  // ─── Общие действия и подписи ────────────────────────────────────────────
  Сохранить: 'Save',
  Отмена: 'Cancel',
  Удалить: 'Delete',
  Заменить: 'Replace',
  'Загрузить или заменить фото': 'Upload or replace photo',
  Изменить: 'Edit',
  'Изменение путевого листа': 'Edit waybill',
  'Изменения сохранены': 'Changes saved',
  Создать: 'Create',
  Добавить: 'Add',
  Поиск: 'Search',
  Загрузка: 'Loading',
  'Нет данных': 'No data',
  Действия: 'Actions',
  Подтвердить: 'Confirm',
  Закрыть: 'Close',
  Печать: 'Print',
  Скачать: 'Download',
  Обновить: 'Refresh',
  Категория: 'Category',
  Статус: 'Status',
  Состояние: 'State',
  Период: 'Period',
  Дата: 'Date',
  Примечание: 'Note',
  Основание: 'Reference',
  Телефон: 'Phone',
  Адрес: 'Address',
  Город: 'City',
  Активен: 'Active',
  'В работе': 'In service',
  Отключён: 'Disabled',
  'Всего:': 'Total:',
  'Записей:': 'Records:',
  Модель: 'Model',
  Наименование: 'Name',
  Код: 'Code',
  Тип: 'Type',
  'Часовой пояс': 'Time zone',

  // ─── Таблицы: настройка колонок ──────────────────────────────────────────
  'Вернуть исходный порядок и ширину колонок': 'Restore default column order and width',

  // ─── Вход ────────────────────────────────────────────────────────────────
  'Вход в систему': 'Sign in',
  'Учёт и контроль спецтранспорта аэропортов': 'Airport ground support fleet management',
  'Электронная почта': 'Email',
  Пароль: 'Password',
  Войти: 'Sign in',
  'Нет доступа?': 'No access?',
  // Платформа: организации и их офисы
  'Офис добавлен': 'Office added',
  'В организации пока нет офисов': 'This organization has no offices yet',
  'Код офиса входит в номера документов и после создания не меняется': 'The office code is part of document numbers and cannot be changed after creation',
  'Новый офис': 'New office',
  'Нажмите на строку организации, чтобы раскрыть её офисы. Офис не удаляется — он отключается: исчезает из переключателя и рабочих списков, а техника, путевые листы и история остаются, и включить его можно в любой момент.': 'Click an organization row to expand its offices. Offices are not deleted but disabled: they disappear from the switcher and working lists, while vehicles, waybills and history remain, and the office can be enabled again at any time.',
  // Телеметрия: карта Google
  'Карта Google недоступна — показана резервная': 'Google map is unavailable — showing the fallback map',
  'Карта не подключена': 'Map is not connected',
  'В сборке сайта не задан ключ карт (переменная VITE_GOOGLE_MAPS_API_KEY). Добавьте его в .env.production на сервере и пересоберите сайт — карта появится сама.': 'The map key (VITE_GOOGLE_MAPS_API_KEY) is not set in this build. Add it to .env.production on the server and rebuild the site — the map will appear on its own.',
  'Карта Google не открылась': 'Google map failed to open',
  // Печать путевого листа
  'Второй водитель': 'Co-driver',
  'Наработка за смену': 'Engine hours per shift',
  'Пробег за смену': 'Mileage per shift',
  'Одометр': 'Odometer',
  'Топливо на начало': 'Fuel at start',
  'Заправка': 'Refuelling',
  'Задания': 'Tasks',
  'Рейс': 'Flight',
  'Борт': 'Aircraft',
  'Стоянка': 'Stand',
  'Куда': 'To',
  'км': 'km',
  'мч': 'eh',
  'Заправки по листу': 'Refuellings on this waybill',
  'Документ': 'Document',
  'Ёмкость': 'Tank',
  'Объём, л': 'Volume, l',
  'Расшифровка расчёта нормы': 'Fuel norm breakdown',
  'Составляющая': 'Component',
  'Ставка': 'Rate',
  'Объём': 'Quantity',
  'Литров': 'Litres',
  'Заключения': 'Clearances',
  'Кто': 'Role',
  'Заключение': 'Conclusion',
  'Дата и время': 'Date and time',
  'Подпись': 'Signature',
  'Медработник': 'Medical officer',
  'Механик': 'Mechanic',
  'Путевой лист выдан': 'Waybill issued',
  'Допущен к рейсу': 'Fit for duty',
  'Допущен с замечаниями': 'Fit with remarks',
  'Не допущен': 'Not fit for duty',
  'Выпуск разрешён': 'Release approved',
  'Выпуск разрешён с замечаниями': 'Release approved with remarks',
  'Выпуск запрещён': 'Release denied',
  // Территория офиса
  'Территория офиса на карте': 'Office area on the map',
  'Карта телеметрии не уходит дальше этого расстояния от центра': 'The telemetry map does not go further than this distance from the centre',
  'Выбор на карте работает с картой Google — задайте её ключ в сборке сайта': 'Map picking requires Google Maps — set its key in the site build',
  'Указать на карте': 'Pick on map',
  'Ничего не найдено — уточните запрос или найдите место на карте': 'Nothing found — refine the query or find the place on the map',
  'Поиск по адресу не включён: в Google Cloud включите Geocoding API и добавьте его в ограничения ключа. Место можно найти на карте вручную.': 'Address search is not enabled: enable the Geocoding API in Google Cloud and add it to the key restrictions. You can still find the place on the map manually.',
  'Территория офиса': 'Office area',
  'Применить': 'Apply',
  'Найдите место поиском или передвиньте карту, затем щёлкните по центру территории (базы, аэропорта, склада). Радиус — насколько далеко от центра работает техника офиса.': 'Find the place by search or move the map, then click the centre of the area (depot, airport, warehouse). The radius is how far from the centre the office vehicles operate.',
  'Найти': 'Find',
  'Адрес или название места, например: Самарканд, аэропорт': 'Address or place name, e.g. Samarkand airport',
  'Карта Google недоступна': 'Google map is unavailable',
  'Радиус, км': 'Radius, km',
  'Центр не выбран — щёлкните по карте': 'No centre selected — click on the map',
  'Безопасность дорог': 'Road safety',
  'Лимит нарушений': 'Violation limit',
  'За период, месяцев': 'Period, months',
  // Печать: выдача в обход, масштаб листа
  'Выдан без заключения по решению диспетчера': 'Issued without clearance by the dispatcher’s decision',
  'Причина': 'Reason',
  'Содержимое не помещается на один лист даже в мелком масштабе — низ листа обрезан. Сократите задания или примечание.': 'The content does not fit on one sheet even at a small scale — the bottom is cut off. Shorten the tasks or notes.',
  'Лист уменьшен до': 'The sheet is scaled down to',
  'чтобы поместиться на одну страницу — проверьте, читается ли шрифт.': 'to fit on one page — check that the text is readable.',
  // Справочники организации
  'Справочник организации — общий для всех её офисов, у других организаций свой. Изменять может администратор организации. Плотность нужна для перевода литров в тонны — бухгалтерия считает ГСМ в килограммах.': 'Organization dictionary — shared by all its offices; other organizations have their own. Only the organization administrator can change it. Density converts litres to tonnes — accounting counts fuel in kilograms.',
  'Справочник организации — общий для всех её офисов: так сравнивается расход одинаковой техники в разных офисах. Изменять может администратор организации. Тип счётчика определяет, по какой базе считается норма расхода.': 'Organization dictionary — shared by all its offices, so fuel use of identical vehicles can be compared across offices. Only the organization administrator can change it. The meter type determines the basis for the fuel norm.',
  'Организация сама заводит свои типы допусков — «Охраняемая территория», «Склад ГСМ» и т.п. Справочник общий для всех её офисов, изменять может администратор организации. Технике можно назначить требуемый тип в её карточке, сотруднику выдаётся сам допуск в карточке сотрудника.': 'The organization defines its own permit types — “Restricted area”, “Fuel depot”, etc. The list is shared by all its offices; only the organization administrator can change it. A vehicle can require a permit type in its card; the permit itself is issued in the employee card.',
  'Каталог документов личного дела — «Паспорт», «Диплом», «Виза» и т.п. — организация заводит сама; он общий для всех её офисов, изменять может администратор организации. Сами документы прикрепляются в карточке сотрудника.': 'The catalogue of personnel documents — “Passport”, “Diploma”, “Visa”, etc. — is defined by the organization and shared by all its offices; only the organization administrator can change it. The documents themselves are attached in the employee card.',
  'Поставщики ГСМ и подрядчики по ремонту. Справочник организации — общий для всех её офисов, изменять может администратор организации.': 'Fuel suppliers and repair contractors. Organization dictionary — shared by all its offices; only the organization administrator can change it.',
  'Справочник службы безопасности дорог — общий для всех офисов организации, у других организаций свой. Изменять может администратор организации.': 'Road safety dictionary — shared by all offices of the organization; other organizations have their own. Only the organization administrator can change it.',
  'Общий справочник платформы — география страны, одна для всех организаций. Нужен для раскладки задания «Регион / Район». Изменять может только суперадминистратор.': 'Platform-wide dictionary — the country’s geography, the same for all organizations. Used by the “Region / District” task layout. Only the super administrator can change it.',
  'Номенклатура организации — общая для всех её офисов, остатки — свои у каждого склада. Позиции заводят администратор организации, администратор офиса, начальник автослужбы и кладовщик; изменять и отключать их может только администратор организации.': 'The organization’s item catalogue — shared by all its offices; stock balances are per warehouse. Items are added by the organization administrator, the office administrator, the fleet manager and the storekeeper; only the organization administrator can change or disable them.',
  'Уникален в пределах организации: по нему сводится расход по всем её офисам': 'Unique within the organization: consumption across all its offices is summed by it',
  // Глобальные настройки
  'Глобальные настройки': 'Global settings',
  // Резервуары
  'Резервуары топливного склада активного офиса — свои у каждого офиса. Пустую ёмкость можно удалить; если в ней остаётся топливо, система попросит сначала списать остаток актом инвентаризации в разделе «Топливо».': 'Fuel depot tanks of the active office — each office has its own. An empty tank can be deleted; if fuel remains, the system will ask you to write off the balance with an inventory report in the “Fuel” section first.',
  // Заявки на транспорт
  'Заявки на транспорт': 'Transport requests',
  'Заявка на транспорт': 'Transport request',
  'Заявка': 'Request',
  'Новая': 'New',
  'Назначена': 'Assigned',
  'Выполнена': 'Completed',
  'Отменена': 'Cancelled',
  'Новые': 'New',
  'Назначены': 'Assigned',
  'Выполнены': 'Completed',
  'Отменены': 'Cancelled',
  'Все': 'All',
  'Принять заявку': 'Take a request',
  'Новая заявка на транспорт': 'New transport request',
  'Заявка принята': 'Request registered',
  'Заявка сохранена': 'Request saved',
  'Заявка назначена': 'Request assigned',
  'Заявка отменена': 'Request cancelled',
  'Заявка снята с путевого листа': 'Request removed from the waybill',
  'Нет прав на просмотр заявок': 'You have no permission to view requests',
  'Номер, заказчик, маршрут': 'Number, customer, route',
  'Когда': 'When',
  'Заказчик': 'Customer',
  'Маршрут': 'Route',
  'Нужна техника': 'Vehicle needed',
  'пасс.': 'pax',
  'т': 't',
  'Назначить машину': 'Assign a vehicle',
  'Отменить заявку': 'Cancel request',
  'Снять заявку с путевого листа?': 'Remove the request from the waybill?',
  'Задание будет удалено из листа, заявка снова будет ждать машину.': 'The task will be removed from the waybill and the request will wait for a vehicle again.',
  'Снять': 'Remove',
  'Снять с путевого листа': 'Remove from waybill',
  'Укажите причину': 'Specify the reason',
  'Когда нужна машина': 'Vehicle needed at',
  'Укажите время подачи': 'Specify the pickup time',
  'До какого времени': 'Until',
  'Окончание должно быть позже начала': 'The end must be later than the start',
  'Подразделение-заказчик': 'Requesting department',
  'Не из подразделений офиса': 'Not from the office departments',
  'Кто заказал': 'Requested by',
  'Укажите заказчика': 'Specify who requested it',
  'ФИО или должность': 'Full name or position',
  'Телефон для связи': 'Contact phone',
  'Какая техника нужна': 'Vehicle type needed',
  'Любая': 'Any',
  'Пассажиров': 'Passengers',
  'Груз, т': 'Cargo, t',
  'Цель поездки': 'Purpose of the trip',
  'Назначить заявку': 'Assign request',
  'Назначить': 'Assign',
  'В оформленный лист': 'To an existing waybill',
  'Новый путевой лист': 'New waybill',
  'На это время нет оформленных путевых листов': 'There are no waybills for this time',
  'нужная категория': 'matching type',
  'Выберите технику': 'Select a vehicle',
  'Выберите водителя': 'Select a driver',
  'Период путевого листа': 'Waybill period',
  'Укажите период': 'Specify the period',
  'Будет создан черновик путевого листа с заданием по этой заявке. Выдать его водителю можно в журнале путевых листов.': 'A draft waybill with a task for this request will be created. You can issue it to the driver in the waybill log.',
  'По заявке': 'Per request',
  // Заявки на транспорт — меню
  'Заявки': 'Requests',
  // Заявки на транспорт — перепечатка
  'Лист уже выдан водителю — после назначения перепечатайте его и сообщите водителю о новом задании.': 'The waybill has already been issued — after assigning, reprint it and tell the driver about the new task.',
  'Задание будет удалено из выданного листа — перепечатайте лист и сообщите водителю.': 'The task will be removed from the issued waybill — reprint the waybill and tell the driver.',
  // Пользователи
  'скрыто': 'hidden',
  // Экран входа
  'Платформа управления автопарком': 'Fleet management platform',
  'Отправьте письмо на электронную почту': 'Send an email to',
  'Восстановление пароля FleetCore': 'FleetCore password recovery',
  'Укажите в письме свою почту для входа — администратор задаст новый пароль.': 'Include your sign-in email — an administrator will set a new password.',
  'Введите электронную почту': 'Enter your email',
  'Неверный формат электронной почты': 'Invalid email format',
  'Пароль — не короче 8 символов': 'Password must be at least 8 characters',
  'Добро пожаловать в FleetCore!': 'Welcome to FleetCore!',
  'Войдите, чтобы продолжить работу': 'Sign in to continue',
  'Сегодня': 'Today',
  'Вход…': 'Signing in…',
  'Обратитесь к администратору вашего офиса': 'Contact your office administrator',
  'учётные записи заводятся вручную, самостоятельной регистрации в системе нет.':
    'accounts are created manually — there is no self-service registration.',

  // ─── Главная ─────────────────────────────────────────────────────────────
  'Единиц техники': 'Vehicles',
  'В строю': 'In service',
  Водителей: 'Drivers',
  'Открытых путевых листов': 'Open waybills',
  'Остатки в ёмкостях': 'Tank levels',
  'Истекающие документы': 'Expiring documents',
  'Осталось дней': 'Days left',
  Просрочено: 'Expired',

  // ─── Транспорт ───────────────────────────────────────────────────────────
  'Транспорт и спецтехника': 'Vehicles and ground support equipment',
  'Поставить на учёт': 'Register vehicle',
  'Гаражный номер, госномер, VIN': 'Fleet number, plate, VIN',
  Гаражный: 'Fleet no.',
  'Гаражный номер': 'Fleet number',
  Госномер: 'Plate',
  'Одометр, км': 'Odometer, km',
  Моточасы: 'Engine hours',
  'В баке, л': 'In tank, L',
  Фото: 'Photo',
  'Показать фото': 'Show photo',
  Загружено: 'Uploaded',
  'Сейчас за рулём': 'Currently driven by',
  Свободна: 'Available',
  'Списать технику с учёта?': 'Decommission this vehicle?',
  'Документы за прошлые периоды сохранятся.': 'Records for past periods are kept.',
  Списать: 'Decommission',
  'Техника списана с учёта': 'Vehicle decommissioned',
  'Нет прав на просмотр транспорта': 'No permission to view vehicles',
  'Выберите офис': 'Select an office',
  'Укажите дату': 'Enter a date',

  // ─── Водители ────────────────────────────────────────────────────────────
  'Принять водителя': 'Add driver',
  'Фамилия или табельный номер': 'Last name or personnel number',
  Табельный: 'Personnel no.',
  ФИО: 'Full name',
  Подразделение: 'Department',
  'Ближайший срок': 'Next expiry',
  'нет документов': 'no documents',
  '(просрочен)': '(expired)',
  Работает: 'Employed',
  Уволен: 'Dismissed',
  'Удалить водителя?': 'Delete this driver?',
  'Водитель удалён': 'Driver deleted',
  'Водитель принят': 'Driver added',
  'Карточка обновлена': 'Record updated',
  'Нет прав на просмотр водителей': 'No permission to view drivers',
  'Дата приёма': 'Hire date',
  'Дата создания': 'Created',
  'Обратитесь в службу поддержки': 'Contact technical support',
  'Топливо, техника, путевые листы и нарушения — в одной системе': 'Fuel, vehicles, waybills and violations — in one system',
  'Вход в аккаунт': 'Sign in to your account',
  'Добро пожаловать!': 'Welcome back!',
  'Введите почту и пароль': 'Enter your email and password',
  'Забыли пароль?': 'Forgot password?',
  'Введите пароль': 'Enter your password',
  'Пароль сбрасывает администратор вашего офиса — обратитесь к нему, и он задаст новый.': 'Your office administrator resets the password — contact them and they will set a new one.',
  'Понятно': 'Got it',
  'не указан': 'not specified',
  'Доступно офисов': 'Offices available',
  'Офис': 'Office',
  'Основной': 'Main',
  'Карта Яндекса не подключена': 'Yandex Maps is not connected',
  'В сборке сайта не задан ключ Яндекс.Карт (переменная VITE_YANDEX_MAPS_API_KEY). Добавьте его в настройках сайта на Render и пересоберите сайт — карта появится сама.': 'The Yandex Maps key (VITE_YANDEX_MAPS_API_KEY) is not set in this build. Add it in the site settings on Render and rebuild the site — the map will appear on its own.',
  'Широта': 'Latitude',
  'Долгота': 'Longitude',
  'Центр карты телеметрии. Чтобы узнать координаты: на Яндекс.Картах щёлкните правой кнопкой по нужному месту — они появятся в подсказке.': 'Center of the telemetry map. To find coordinates: right-click the place on Yandex Maps — they appear in the hint.',
  'Карта Яндекса недоступна — показана резервная (OpenStreetMap)': 'Yandex Maps is unavailable — showing the fallback map (OpenStreetMap)',
  'Геозона': 'Geofence',
  'Геозоны': 'Geofences',
  'Новая геозона': 'New geofence',
  'Геозона сохранена': 'Geofence saved',
  'Геозона создана': 'Geofence created',
  'Геозона удалена': 'Geofence deleted',
  'Состояние геозоны изменено': 'Geofence status changed',
  'Добавить зону': 'Add zone',
  'Действует': 'Active',
  'Удалить геозону?': 'Delete geofence?',
  'Вместе с ней удалятся и записанные въезды и выезды. Чтобы сохранить историю, лучше отключить зону.': 'Recorded entries and exits will be deleted with it. To keep the history, disable the zone instead.',
  'Обведите зону на карте: минимум три точки, контур нужно замкнуть.': 'Outline the zone on the map: at least three points, and the outline must be closed.',
  'Контур пересекает сам себя — поправьте точки.': 'The outline crosses itself — adjust the points.',
  'Щёлкайте по карте, ставя углы зоны.': 'Click the map to place the corners of the zone.',
  'Поставьте ещё точки — нужно минимум три.': 'Add more points — at least three are needed.',
  'Замкните контур: щёлкните по первой точке или нажмите «Замкнуть».': 'Close the outline: click the first point or press “Close”.',
  'Теперь щёлкните точку на границе круга — это задаст радиус.': 'Now click a point on the edge of the circle — this sets the radius.',
  'Теперь щёлкните противоположный угол прямоугольника.': 'Now click the opposite corner of the rectangle.',
  'Щёлкните центр круга.': 'Click the center of the circle.',
  'Щёлкните один из углов прямоугольника.': 'Click one corner of the rectangle.',
  'Тяните точки, чтобы подвинуть. Щёлкните по линии — добавится точка. Двойной щелчок по точке удаляет её.': 'Drag points to move them. Click a line to add a point. Double-click a point to delete it.',
  'Многоугольник': 'Polygon',
  'Круг': 'Circle',
  'Прямоугольник': 'Rectangle',
  'Замкнуть': 'Close',
  'Убрать последнюю точку': 'Remove last point',
  'Обвести заново': 'Redraw',
  'Радиус, м': 'Radius, m',
  'Подложка карты не загрузилась — проверьте подключение к интернету. Зону можно обвести и без неё.': 'The map background failed to load — check your internet connection. You can still outline the zone without it.',
  'Точек': 'Points',
  'Площадь': 'Area',
  'га': 'ha',
  'м²': 'm²',
  'Например: Перрон 2': 'For example: Apron 2',
  'Цвет': 'Color',
  'Цвета': 'Colors',
  'Ограничение скорости, км/ч': 'Speed limit, km/h',
  'Если техника едет быстрее внутри зоны, появится оповещение. Пусто — без ограничения.': 'If a vehicle exceeds this speed inside the zone, an alert is raised. Empty — no limit.',
  'Оповещать о въезде': 'Alert on entry',
  'Оповещать о выезде': 'Alert on exit',
  'Зона действует': 'Zone is active',
  'Как у организации': 'Same as organization',
  'Раскладка задания': 'Task layout',
  'Общие для всех офисов организации. Отдельному офису можно задать свою раскладку.': 'Shared by all offices of the organization. An individual office can set its own layout.',
  'По умолчанию раскладка общая для всей организации. Свою задают только офисам, которым она нужна отдельно.': 'By default the layout is shared by the whole organization. Set your own only for offices that need it separately.',
  'Администратор организации': 'Organization admin',
  'Видит и ведёт все офисы выбранных организаций, но не чужие. Ниже укажите хотя бы один офис — в него человек попадает после входа.': 'Sees and manages all offices of the selected organizations, but not others. Below, specify at least one office — the person lands there after sign-in.',
  'Не администратор организации': 'Not an organization admin',
  'Платформа': 'Platform',
  'Организации': 'Organizations',
  'Организация': 'Organization',
  'Офисы': 'Offices',
  'Офисов': 'Offices',
  'Суперадминистраторы': 'Super admins',
  'Нет прав на управление платформой': 'No permission to manage the platform',
  'Создать организацию': 'Create organization',
  'Новая организация': 'New organization',
  'Организация создана': 'Organization created',
  'Организация обновлена': 'Organization updated',
  'Состояние организации изменено': 'Organization status changed',
  'Отключена': 'Disabled',
  'Отключить организацию?': 'Disable organization?',
  'Включить организацию?': 'Enable organization?',
  'Все её офисы исчезнут из переключателя, сотрудники не смогут войти. Данные сохранятся.': 'All its offices will disappear from the switcher and staff will not be able to sign in. Data is kept.',
  'Офисы организации вернутся в переключатель.': 'The organization’s offices will return to the switcher.',
  'Организация — отдельный клиент платформы, например «Аэропорты Узбекистана» или TOSHSHAHARNUR. Данные разных организаций не смешиваются. Отключённая организация закрывает вход во все свои офисы, история при этом сохраняется.': 'An organization is a separate client of the platform, e.g. “Airports of Uzbekistan” or TOSHSHAHARNUR. Data of different organizations is never mixed. A disabled organization blocks sign-in to all its offices; history is preserved.',
  '2–16 заглавных латинских букв или цифр. После создания не меняется.': '2–16 capital Latin letters or digits. Cannot be changed after creation.',
  '2–16 заглавных латинских букв или цифр': '2–16 capital Latin letters or digits',
  'Название (рус)': 'Name (Russian)',
  'Название (узб)': 'Name (Uzbek)',
  'Название (англ)': 'Name (English)',
  'Суперадминистратор платформы видит все организации и офисы, в том числе созданные позже, и может переключаться между ними. Администратор офиса работает только в рамках своего офиса. Статус выдаётся отметкой в карточке пользователя.': 'A platform super admin sees all organizations and offices, including ones created later, and can switch between them. An office admin works only within their own office. The status is granted by a checkbox in the user card.',
  'Добавить суперадминистратора': 'Add super admin',
  'Суперадминистратор платформы': 'Platform super admin',
  'Суперадминистратор платформы отмечается отдельно и видит все офисы всех организаций, в том числе созданные позже.': 'A platform super admin is marked separately and sees all offices of all organizations, including ones created later.',
  'Полный доступ ко всем организациям и офисам, управление организациями и офисами. Ниже укажите хотя бы один офис — в него человек попадает после входа.': 'Full access to all organizations and offices, including managing them. Below, specify at least one office — the person lands there after sign-in.',
  'Выберите организацию': 'Select organization',
  'Клиент платформы, которому принадлежит офис. После создания не меняется.': 'The platform client the office belongs to. Cannot be changed after creation.',
  'Почта': 'Email',
  'Последний вход': 'Last sign-in',
  'ни разу': 'never',
  'Дата увольнения': 'Dismissal date',
  Должность: 'Position',
  'Должность водителя': 'Driver position',
  'Сейчас на технике': 'Currently driving',
  'Не за рулём': 'Not on duty',
  'Должности водителей': 'Driver positions',
  'Список должностей свой у каждого подразделения: водитель легкового транспорта в службе спецтранспорта и водитель погрузчика на складе — разные записи, даже если оба «водитель».':
    'Each department keeps its own list of positions: a car driver in the ground fleet service and a forklift driver in the warehouse are separate entries, even though both are "drivers".',
  'Сначала выберите подразделение': 'Select a department first',
  Масштаб: 'Zoom',
  'Перетащите фото и настройте масштаб, чтобы выбрать область для квадратного снимка':
    'Drag the photo and adjust the zoom to choose the area for the square photo',
  Фамилия: 'Last name',
  Имя: 'First name',
  Отчество: 'Middle name',
  'Дата рождения': 'Date of birth',
  'Табельный номер': 'Personnel number',
  'Обязательное поле': 'Required field',
  'После заполнения водитель исчезнет из списка выдачи путевых листов':
    'Once filled in, the driver is removed from the waybill issuing list',
  Передать: 'Transfer',
  'Приказ № ... от ...': 'Order no. ... dated ...',

  // ─── Путевые листы ───────────────────────────────────────────────────────
  'Номер листа': 'Waybill number',
  Номер: 'Number',
  Техника: 'Vehicle',
  Водитель: 'Driver',
  'Только перерасход': 'Overconsumption only',
  'Пробег, км': 'Distance, km',
  'Норма, л': 'Norm, L',
  'Факт, л': 'Actual, L',
  Отклонение: 'Deviation',
  'Нет прав на просмотр путевых листов': 'No permission to view waybills',
  'Нет прав на печать путевых листов': 'No permission to print waybills',
  'Путевой лист': 'Waybill',
  'Путевой лист не найден': 'Waybill not found',
  'Совет: чтобы сохранить в PDF, в диалоге печати выберите «Сохранить как PDF»':
    'Tip: to save as PDF, choose "Save as PDF" in the print dialog',
  Диспетчер: 'Dispatcher',
  Сформировано: 'Generated',

  // ─── Нарушения (служба безопасности дорог) ───────────────────────────────
  Нарушения: 'Violations',
  'Нет прав на просмотр нарушений': 'No permission to view violations',
  'Оформление нарушения': 'Recording a violation',
  'Оформить нарушение': 'Record violation',
  'Вид нарушения': 'Violation type',
  'Виды нарушений': 'Violation types',
  'Сумма штрафа': 'Fine amount',
  Штраф: 'Fine',
  'Штраф по умолчанию': 'Default fine amount',
  Описание: 'Description',
  'Фото/вложение': 'Photo/attachment',
  'Сфотографировать / выбрать файл': 'Take photo / choose file',
  'Нарушение оформлено': 'Violation recorded',
  Участники: 'Parties involved',
  Нарушение: 'Violation',
  Доказательство: 'Evidence',
  'Сохранение…': 'Saving…',
  'Адрес А': 'Address A',
  'Адрес Б': 'Address B',
  Локация: 'Location',
  Регион: 'Region',
  Район: 'District',
  Районы: 'Districts',
  'Регионы и районы': 'Regions and districts',
  'Регион / Район (административное деление)': 'Region / District (administrative division)',
  'Локации заданий': 'Task locations',
  'Поля заданий путевого листа': 'Waybill task fields',
  Раскладка: 'Layout',
  'Рейс/Борт/Стоянка — для аэропортов; Адрес А/Б — для остальных сфер':
    'Flight/Tail/Stand — for airports; Address A/B — for other industries',
  '«Адрес А» — список локаций': '"Address A" — pick from location list',
  'Вместо свободного текста — выбор из справочника «Локации заданий»':
    'A dropdown from the "Task locations" dictionary instead of free text',
  'Нумерация документов': 'Document numbering',
  'Префикс по каждому виду документа, например «ТТН» вместо «PL» — под собственную нумерацию организации. Пустое поле — значение платформы по умолчанию.':
    'Prefix per document type, e.g. a custom code instead of "PL" — to match the organization\'s own numbering. Empty — use the platform default.',
  'Заглавные буквы, цифры, дефис, до 12 символов': 'Uppercase letters, digits, hyphen, up to 12 characters',
  'Приход ГСМ': 'Fuel receipt',
  'Выдача ГСМ': 'Fuel issue',
  'Наряд-заказ': 'Work order',
  'Инвентаризационный акт': 'Inventory act',
  'Акт состояния техники': 'Condition act',
  'Приход ТМЦ': 'Stock receipt',
  'Выдача ТМЦ': 'Stock issue',
  'Возврат ТМЦ': 'Stock return',
  'Списание ТМЦ': 'Stock write-off',
  'Перемещение ТМЦ': 'Stock transfer',
  'Склад №1': 'Warehouse No. 1',
  'Рейс / Борт / Стоянка (авиация)': 'Flight / Tail / Stand (aviation)',
  'Адрес А / Адрес Б (универсальная)': 'Address A / Address B (universal)',
  'Новая ёмкость': 'New tank',
  'Изменить ёмкость': 'Edit tank',
  'Ёмкость добавлена': 'Tank added',
  'Ёмкость изменена': 'Tank updated',
  'Ёмкость удалена': 'Tank deleted',
  'Удалить ёмкость?': 'Delete this tank?',
  'Вид топлива': 'Fuel type',
  'Короткий код, уникальный в пределах офиса, например REZ-2':
    'A short code, unique within the office, e.g. REZ-2',
  Название: 'Name',
  'Резервуар ДТ №2': 'Diesel tank No. 2',
  'Вместимость, л': 'Capacity, L',
  'Порог низкого остатка, л': 'Low-level threshold, L',
  'Ниже этого остатка ёмкость подсвечивается как требующая внимания':
    'Below this level the tank is flagged as needing attention',
  'Текущий остаток, л': 'Current level, L',
  'Если ёмкость уже эксплуатируется и в ней есть топливо — укажите остаток на момент постановки на учёт. По умолчанию 0.':
    'If the tank is already in use and has fuel in it, enter the level as of registration. Defaults to 0.',
  Расположение: 'Location',
  'Топливный склад, сектор B': 'Fuel depot, sector B',
  Активна: 'Active',
  Неактивна: 'Inactive',
  'Выключенная ёмкость остаётся в истории, но не предлагается для новых операций':
    'A disabled tank stays in history but is not offered for new operations',
  'Мобильный режим': 'Mobile mode',
  'Открыть мобильный экран для оформления в поле': 'Open the mobile screen for recording violations on site',
  'Оформить ещё одно': 'Record another',
  'Начните вводить фамилию': 'Start typing last name',
  'Гаражный номер или госномер': 'Garage number or plate',
  'Нет доступа': 'No access',
  'У вашей учётной записи нет прав на оформление нарушений':
    'Your account does not have permission to record violations',
  'Запись удалена': 'Record deleted',
  'Удалить запись о нарушении?': 'Delete this violation record?',
  Оформил: 'Recorded by',
  'Справочник службы безопасности дорог. Свой у каждого аэропорта: перечень нарушений и суммы штрафов по умолчанию могут отличаться.':
    'Road safety service directory. Each airport keeps its own: the list of violations and default fine amounts may differ.',

  // ─── Категории техники ───────────────────────────────────────────────────
  'Перронный автобус': 'Apron bus',
  'Тягач (pushback)': 'Pushback tug',
  'Багажный тягач': 'Baggage tug',
  'Ленточный транспортёр': 'Belt loader',
  Амбулифт: 'Ambulift',
  Деайсер: 'De-icer',
  Топливозаправщик: 'Refueller',
  'Источник питания (GPU)': 'Ground power unit (GPU)',
  'Установка воздушного запуска': 'Air start unit (ASU)',
  'Кондиционер ВС': 'Air conditioning unit',
  'Машина бортпитания': 'Catering truck',
  Водозаправщик: 'Water truck',
  Ассенизатор: 'Lavatory truck',
  'Контейнерный погрузчик': 'Cargo loader',
  Снегоуборочная: 'Snow removal',
  'Пожарный автомобиль': 'Fire truck',
  Легковой: 'Car',
  'Служебный автобус': 'Staff bus',
  Грузовой: 'Truck',
  Автопогрузчик: 'Forklift',
  Прицеп: 'Trailer',
  'Стационарное оборудование': 'Stationary equipment',
  Прочее: 'Other',

  // ─── Состояние техники ───────────────────────────────────────────────────
  'На ТО': 'Maintenance',
  'В ремонте': 'Under repair',
  'В резерве': 'Reserve',
  'В передаче': 'In transfer',
  Списана: 'Decommissioned',

  // ─── Счётчики и владение ────────────────────────────────────────────────
  'Одометр (км)': 'Odometer (km)',
  'Одометр и моточасы': 'Odometer and engine hours',
  'Без счётчика': 'No meter',
  Собственная: 'Owned',
  Лизинг: 'Leased',
  Аренда: 'Rented',

  // ─── Документы и допуски ────────────────────────────────────────────────
  'Свидетельство о регистрации': 'Registration certificate',
  Техосмотр: 'Technical inspection',
  'Пропуск на перрон': 'Airside vehicle permit',
  'Свидетельство о поверке': 'Calibration certificate',
  'Договор лизинга': 'Lease contract',
  Тахограф: 'Tachograph',
  'Водительское удостоверение': 'Driving licence',
  Медосмотр: 'Medical check',
  'Допуск: перрон': 'Permit: apron',
  'Допуск: контролируемая зона': 'Permit: airside',
  'Допуск: ВПП': 'Permit: runway',
  'Допуск: площадь манёврирования': 'Permit: manoeuvring area',
  'Допуск: привокзальная зона': 'Permit: landside',
  'Привокзальная зона': 'Landside',
  'Контролируемая зона': 'Airside',
  Перрон: 'Apron',
  'Площадь манёврирования': 'Manoeuvring area',
  ВПП: 'Runway',

  // ─── Статусы путевого листа ─────────────────────────────────────────────
  Черновик: 'Draft',
  Выдан: 'Issued',
  Сдан: 'Submitted',
  Закрыт: 'Closed',
  Аннулирован: 'Cancelled',

  // ─── Нормы и источники топлива ──────────────────────────────────────────
  'л на 100 км': 'L per 100 km',
  'л на моточас': 'L per engine hour',
  'л на операцию': 'L per operation',
  'л на т·км': 'L per tonne-km',
  'л на смену': 'L per shift',
  'Из ёмкости': 'From tank',
  'Топливная карта': 'Fuel card',
  Наличные: 'Cash',
  'Сторонний поставщик': 'External supplier',

  // ─── Офисы ───────────────────────────────────────────────────────────────
  'Головной офис': 'Headquarters',
  Аэропорт: 'Airport',
  Филиал: 'Branch',
  Логотип: 'Logo',
  'Подключить аэропорт': 'Add airport',
  'Загрузить логотип': 'Upload logo',
  'Заменить логотип': 'Replace logo',
  'Удалить логотип?': 'Delete logo?',
  'Логотип обновлён': 'Logo updated',
  'Логотип удалён': 'Logo deleted',
  'Отключить офис?': 'Disable this office?',
  'Включить офис?': 'Enable this office?',
  Отключить: 'Disable',
  Включить: 'Enable',
  'Состояние офиса изменено': 'Office state changed',
  'Офис обновлён': 'Office updated',
  'Аэропорт подключён': 'Airport added',

  // ─── Выбор строк и выгрузка ──────────────────────────────────────────────
  Выбрано: 'Selected',
  из: 'of',
  'Снять выбор': 'Clear selection',
  Отчёт: 'Report',
  'Сводная таблица': 'Summary table',
  'Отметьте строки галочками': 'Tick the rows first',
  выбранные: 'selected',
  'весь список': 'full list',
  'Код обращения': 'Request code',
  'Сбросить колонки': 'Reset columns',
  'Нет строк для отчёта': 'No rows to report',
  Итого: 'Total',
  'Загрузка строк': 'Loading rows',
  'Формируется отчёт': 'Building the report',
  Таблица: 'Table',
  Строк: 'Rows',
  'Печатные формы': 'Print forms',
  Документов: 'Documents',
  'Не выбрано ни одного документа': 'No documents selected',
  'За один раз печатается не больше документов:': 'Maximum documents per print run:',
  'Выгрузка таблицы': 'Table export',
  'Фото пользователя': 'User photo',
  'После выбора файла можно выбрать область и масштаб. JPEG, PNG или WebP.': 'After choosing a file you can pick the area and zoom. JPEG, PNG or WebP.',
};
